var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebsite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.729 2.10494C12.1694 1.56227 11.5262 1.10525 10.8203 0.755859C11.1612 1.27382 11.4612 1.87321 11.7106 2.54168C12.0687 2.41327 12.409 2.26718 12.729 2.10494Z",
    fill: "url(#paint0_linear_1248_1389)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.74609 6.98026H6.97968V4.24034C6.01333 4.19837 5.07901 4.06223 4.20854 3.83984C3.9479 4.79184 3.78465 5.85789 3.74609 6.98026Z",
    fill: "url(#paint1_linear_1248_1389)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.14508 10.9076C5.03483 10.6743 5.99185 10.5303 6.97948 10.4866V8.01953H3.74609C3.78214 9.04392 3.9222 10.0209 4.14508 10.9076Z",
    fill: "url(#paint2_linear_1248_1389)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.52734 2.84795C5.2952 3.03912 6.12069 3.15709 6.97691 3.19634V0C6.82611 0.0104416 6.67691 0.0253009 6.52872 0.0445777C5.72833 0.529913 5.02734 1.53161 4.52734 2.84795Z",
    fill: "url(#paint3_linear_1248_1389)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.17188 12.8001C2.84315 13.4748 3.64133 14.0224 4.52686 14.4054C4.09795 13.7935 3.72979 13.0544 3.43842 12.2168C2.98381 12.3845 2.55942 12.5795 2.17188 12.8001Z",
    fill: "url(#paint4_linear_1248_1389)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5188 0.597656C3.71369 0.94715 2.98198 1.43349 2.35156 2.02726C2.71431 2.22173 3.10667 2.39261 3.52183 2.54181C3.79692 1.80407 4.13367 1.14996 4.5188 0.597656Z",
    fill: "url(#paint5_linear_1248_1389)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.20236 3.53116C2.63631 3.33016 2.1074 3.08981 1.62538 2.8125C0.698584 3.97182 0.108031 5.40945 0 6.97831H2.70217C2.74042 5.73746 2.91602 4.57352 3.20236 3.53116Z",
    fill: "url(#paint6_linear_1248_1389)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.70237 8.01953H0C0.102107 9.50455 0.635333 10.8732 1.47799 11.9981C1.97949 11.6968 2.53731 11.4348 3.13881 11.2177C2.89092 10.2402 2.73832 9.16269 2.70237 8.01953Z",
    fill: "url(#paint7_linear_1248_1389)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54861 14.9585C6.69047 14.9762 6.83344 14.9905 6.97772 15.0005V11.5312C6.09108 11.5729 5.23487 11.7 4.44141 11.9046C4.94903 13.3487 5.69239 14.4489 6.54861 14.9585Z",
    fill: "url(#paint8_linear_1248_1389)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0938 11.2133C12.6294 11.4072 13.1317 11.6361 13.591 11.8997C14.3922 10.7935 14.8995 9.46208 14.9987 8.01953H12.5294C12.4935 9.16078 12.3414 10.2371 12.0938 11.2133Z",
    fill: "url(#paint9_linear_1248_1389)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8125 14.2472C11.5976 13.86 12.3048 13.3397 12.9066 12.7161C12.5614 12.5305 12.1882 12.364 11.7927 12.2188C11.5257 12.9845 11.195 13.6681 10.8125 14.2472Z",
    fill: "url(#paint10_linear_1248_1389)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77595 0.0906614C8.52756 0.0479913 8.27525 0.0177708 8.01953 0V3.20648C8.95667 3.17887 9.86208 3.05468 10.7013 2.84534C10.2172 1.57156 9.54461 0.59196 8.77595 0.0906614Z",
    fill: "url(#paint11_linear_1248_1389)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0312 3.53015C12.318 4.5725 12.4935 5.73704 12.5317 6.97809H15.0008C14.8959 5.4493 14.3323 4.0455 13.4462 2.90234C13.0084 3.1411 12.5351 3.35153 12.0312 3.53015Z",
    fill: "url(#paint12_linear_1248_1389)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01953 14.9986C8.26953 14.9816 8.51641 14.952 8.75928 14.9112C9.58266 14.3828 10.2961 13.3045 10.7886 11.9044C9.92382 11.6812 8.98588 11.5486 8.01953 11.5195V14.9986Z",
    fill: "url(#paint13_linear_1248_1389)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0232 3.83594C10.081 4.0771 9.0661 4.21876 8.01953 4.24788V6.97897H11.4868C11.4479 5.85589 11.2843 4.78874 11.0232 3.83594Z",
    fill: "url(#paint14_linear_1248_1389)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4865 8.01953H8.01953V10.4779C9.09703 10.5068 10.1332 10.6508 11.0891 10.9003C11.3112 10.0158 11.4505 9.0413 11.4865 8.01953Z",
    fill: "url(#paint15_linear_1248_1389)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1248_1389",
    x1: 10.7718,
    y1: 1.48143,
    x2: 12.6738,
    y2: 1.63833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF91FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4DFFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1248_1389",
    x1: 3.66387,
    y1: 5.11578,
    x2: 6.88763,
    y2: 5.37198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF91FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4DFFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1248_1389",
    x1: 3.66388,
    y1: 9.19296,
    x2: 6.88376,
    y2: 9.47118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF91FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4DFFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1248_1389",
    x1: 4.46506,
    y1: 1.29866,
    x2: 6.91403,
    y2: 1.44351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF91FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4DFFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1248_1389",
    x1: 2.11199,
    y1: 13.106,
    x2: 4.45847,
    y2: 13.3009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF91FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4DFFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1248_1389",
    x1: 2.29646,
    y1: 1.38755,
    x2: 4.45478,
    y2: 1.57325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF91FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4DFFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1248_1389",
    x1: -0.0814267,
    y1: 4.50504,
    x2: 3.1201,
    y2: 4.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF91FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4DFFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1248_1389",
    x1: -0.0798108,
    y1: 9.636,
    x2: 3.05759,
    y2: 9.82704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF91FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4DFFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1248_1389",
    x1: 4.37692,
    y1: 12.9408,
    x2: 6.91341,
    y2: 13.0839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF91FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4DFFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1248_1389",
    x1: 12.0199,
    y1: 9.59602,
    x2: 14.9246,
    y2: 9.76387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF91FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4DFFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1248_1389",
    x1: 10.7593,
    y1: 13.0429,
    x2: 12.847,
    y2: 13.2093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF91FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4DFFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1248_1389",
    x1: 7.95134,
    y1: 1.30278,
    x2: 10.6307,
    y2: 1.47573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF91FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4DFFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1248_1389",
    x1: 11.9557,
    y1: 4.5583,
    x2: 14.9256,
    y2: 4.7253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF91FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4DFFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1248_1389",
    x1: 7.94912,
    y1: 12.9331,
    x2: 10.7167,
    y2: 13.1031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF91FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4DFFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1248_1389",
    x1: 7.93137,
    y1: 5.11293,
    x2: 11.3848,
    y2: 5.40697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF91FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4DFFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1248_1389",
    x1: 7.93138,
    y1: 9.18998,
    x2: 11.3798,
    y2: 9.51029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF91FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4DFFE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.63aac995a1ef5bdaeef029fed5ae1467.svg";
export { ForwardRef as ReactComponent };